(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/modular-base/assets/javascripts/skeleton/route-my-bets-wager-fallback.js') >= 0) return;  svs.modules.push('/components/tipsen/modular-base/assets/javascripts/skeleton/route-my-bets-wager-fallback.js');
"use strict";

const {
  ReactPaper: Paper
} = svs.ui;
const {
  SkeletonLine,
  SkeletonCircle
} = svs.components.lbUi;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const RouteWagerCouponFallback = _ref => {
  let {
    isWideScreen
  } = _ref;
  return isWideScreen ? React.createElement("div", {
    className: "coupon-match-skeleton"
  }, React.createElement(SkeletonCircle, {
    className: "coupon-match-number-skeleton",
    size: 36
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-team-skeleton"
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-team-skeleton"
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-sign-skeleton"
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-sign-skeleton"
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-sign-skeleton"
  })) : React.createElement("div", {
    className: "pg_my_bets_wager_fallback__grid__coupon__mobile"
  }, React.createElement(SkeletonLine, {
    className: "pg_my_bets_wager_fallback__grid__coupon__mobile__text"
  }));
};
const DrawCardColumnSkeleton = () => React.createElement("div", null, React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__draw_card__title"
}), React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__draw_card__text"
}));
const WinGroupsRowSkeleton = () => React.createElement("div", {
  className: "pg_my_bets_wager_fallback__grid__win_groups__content"
}, React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__win_groups__content__text1"
}), React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__win_groups__content__text2"
}), React.createElement(SkeletonLine, {
  className: "pg_my_bets_wager_fallback__grid__win_groups__content__text3"
}));
const RouteMyBetsWagerFallback = () => {
  const isWideScreen = useMediaQuery(breakpoints.up(BREAKPOINT_MD));
  return React.createElement("div", {
    className: "pg_my_bets_wager_fallback"
  }, React.createElement("div", {
    className: "pg_my_bets_wager_fallback__grid"
  }, React.createElement(Paper, {
    branding: "sport",
    className: "pg_my_bets_wager_fallback__grid__draw_card"
  }, React.createElement(DrawCardColumnSkeleton, null), React.createElement(DrawCardColumnSkeleton, null), React.createElement(DrawCardColumnSkeleton, null), React.createElement("div", null, React.createElement(SkeletonLine, {
    className: "pg_my_bets_wager_fallback__grid__draw_card__participants"
  }), React.createElement(SkeletonLine, {
    className: "pg_my_bets_wager_fallback__grid__draw_card__participants"
  }))), React.createElement(Paper, {
    branding: "sport",
    className: "pg_my_bets_wager_fallback__grid__coupon"
  }, React.createElement("div", {
    className: "pg_my_bets_wager_fallback__grid__coupon__grid"
  }, Array.from({
    length: 13
  }).map((_, i) => {
    const key = "coupon-".concat(i);
    return React.createElement(RouteWagerCouponFallback, {
      isWideScreen: isWideScreen,
      key: key
    });
  }))), React.createElement(Paper, {
    branding: "sport",
    className: "pg_my_bets_wager_fallback__grid__side_nav"
  }, React.createElement("div", {
    className: "coupon-match-info-skeleton"
  }, React.createElement(SkeletonLine, {
    className: "coupon-match-info-title-skeleton"
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-info-data-skeleton"
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-info-data-skeleton"
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-info-data-skeleton"
  })), React.createElement("div", {
    className: "coupon-match-info-skeleton"
  }, React.createElement(SkeletonLine, {
    className: "coupon-match-info-title-skeleton"
  }), React.createElement(SkeletonLine, {
    className: "coupon-match-info-data-skeleton"
  }))), React.createElement(Paper, {
    branding: "sport",
    className: "pg_my_bets_wager_fallback__grid__result_card"
  }, React.createElement(SkeletonLine, {
    className: "pg_my_bets_wager_fallback__grid__result_card__header"
  }), React.createElement(SkeletonLine, {
    className: "pg_my_bets_wager_fallback__grid__result_card__footer"
  })), React.createElement(Paper, {
    branding: "sport",
    className: "pg_my_bets_wager_fallback__grid__win_groups"
  }, Array.from({
    length: 5
  }).map((_, i) => {
    const key = "win-groups-".concat(i);
    return React.createElement(WinGroupsRowSkeleton, {
      key: key
    });
  })), React.createElement(Paper, {
    branding: "sport",
    className: "pg_my_bets_wager_fallback__grid__receipt"
  }, React.createElement(SkeletonLine, {
    className: "pg_my_bets_wager_fallback__grid__receipt__text"
  })), React.createElement(Paper, {
    branding: "sport",
    className: "pg_my_bets_wager_fallback__grid__container_btns"
  }, React.createElement(SkeletonLine, {
    className: "pg_my_bets_wager_fallback__grid__container_btns__text"
  }))));
};
setGlobal('svs.components.tipsen.modularBase.RouteMyBetsWagerFallback', RouteMyBetsWagerFallback);

 })(window);